import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import { T_ } from '@shared/translation';
import { cdn_url } from '@shared/cdn';
import tpl from '../templates/recoverpassword.html';
import logoTpl from '../templates/fl-logo.html';
import appStoreTpl from '../templates/apple-app-store.html';
import playStoreTpl from '../templates/google-play-store.html';

export default Backbone.View.extend({
  template: _.template(tpl),

  initialize(options) {
    this.vent = options.vent;
    this.$el = $(this.el);
    this.options = {
      title: T_('登录到Freelancer.com'),
      loginTitle: options.loginTitle,
      signupTitle: options.signupTitle,
      hideFacebook: options.hideFacebook,
      hideLookingFor: options.hideLookingFor,
      isLoginSignup: options.isLoginSignup,
      isFreemarket: options.isFreemarket,
      // LJ-375
      switchToAlternateSignup: this.options.hasOwnProperty(
      'switchToAlternateSignup') ?

      this.options.switchToAlternateSignup :
      false };

    this.model.bind('email:valid', this.onValidEmail, this);
    this.model.bind('email:invalid', this.onInvalidEmail, this);
    this.model.bind('success', this.onSuccess, this);
    this.model.bind('error', this.onError, this);
  },

  events: {
    'submit #forgot_password_form': 'submit',
    'click #playStore': 'trackPlayStoreClick',
    'click #appStore': 'trackAppStoreClick',
    'click #header-login-switch': 'showLogin',
    'click .switch-to-login': 'switchToSignup',
    'click .close': 'close',
    'click #fb-login-btn': 'close',
    'focus input': 'clearError' },


  clearError() {
    const inputs = this.$el.find('input');
    inputs.closest('.form-step').removeClass('is-invalid');
    this.$el.
    find('.form-error').
    text('').
    hide();
  },

  onInvalidEmail(reason) {
    this.$el.find('#forgot_password_btn').removeClass('processing');
    const email = this.$el.find('.recover-email-step');
    email.
    find('.email-error').
    text(reason).
    show();
    email.addClass('is-invalid');
  },

  onValidEmail() {
    const email = this.$el.find('.recover-email-step');
    email.find('.email-error').hide();
    email.removeClass('is-invalid');
  },

  onSuccess() {
    // TODO Show OK
    this.$el.find('#forgot_password_form').hide();
    this.$el.find('.recover-success').show();
  },

  onError(reason) {
    this.$el.find('#forgot_password_btn').removeClass('processing');
    const email = this.$el.find('.recover-email-step');
    email.
    find('.email-error').
    text(reason).
    show();
  },

  submit(e) {
    e.preventDefault();
    this.$el.find('#forgot_password_btn').addClass('processing');
    const email = this.$el.find('.recover-email-step');
    email.removeClass('is-invalid');
    this.model.set(
    {
      email: email.find('input[name=email]').val() },

    { silent: true });

    this.model.recoverPassword();
  },

  trackPlayStoreClick(e) {
    e.preventDefault();
    _t.push([
    'user_action',
    {
      section: 'Login',
      subsection: 'DownloadPlayStore',
      label: 'RecoverPwdDownload',
      action: 'click' }]);


  },

  trackAppStoreClick(e) {
    e.preventDefault();
    _t.push([
    'user_action',
    {
      section: 'Login',
      subsection: 'DownloadAppStore',
      label: 'RecoverPwdDownload',
      action: 'click' }]);


  },

  showLogin(e) {
    e.preventDefault();
    const options = {
      recoverPasswordModel: this.model,
      title: this.options.loginTitle,
      signupTitle: this.options.signupTitle,
      hideFacebook: this.options.hideFacebook,
      hideLookingFor: this.options.hideLookingFor,
      isLoginSignup: this.options.isLoginSignup,
      isFreemarket: this.options.isFreemarket,
      switchToAlternateSignup: this.options.switchToAlternateSignup };

    this.vent.trigger('show:login', options);
  },

  switchToSignup(e) {
    e.preventDefault();
    const options = {
      recoverPasswordModel: this.model,
      title: this.options.signupTitle,
      loginTitle: this.options.loginTitle,
      hideFacebook: this.options.hideFacebook,
      hideLookingFor: this.options.hideLookingFor,
      isLoginSignup: this.options.isLoginSignup,
      isFreemarket: this.options.isFreemarket,
      switchToAlternateSignup: this.options.switchToAlternateSignup };

    this.vent.trigger('show:signup', options);
  },

  showFBLogin() {
    this.vent.trigger('show:fblogin', { recoverPasswordModel: this.model });
  },

  render() {
    if (!this.options.isFreemarket) {
      this.options.playStoreUrl = 'https://bnc.lt/Ed5l/nPQu9RdcWr';
      this.options.appStoreUrl = 'https://bnc.lt/Ed5l/nPQu9RdcWr';
    }

    this.$el.html(
    this.template({
      options: this.options,
      model: this.model.toJSON(),
      T_ }));



    if (!this.options.isFreemarket) {
      this.$el.find('#fl-logo').html(_.template(logoTpl)({ cdn_url }));
      this.$el.find('#appStore').html(_.template(appStoreTpl));
      this.$el.find('#playStore').html(_.template(playStoreTpl));
    }
    return this;
  },

  close() {
    this.vent.trigger('close');
  },

  /**
      * Destroy the view. Unbind all references to enable the view
      * to be garbage collected and remove the el from the DOM.
      */
  destroy() {
    this.model.unbind('email:valid', this.onValidEmail, this);
    this.model.unbind('email:invalid', this.onInvalidEmail, this);
    this.model.unbind('success', this.onSuccess, this);
    this.model.unbind('error', this.onError, this);
    this.remove();
  } });